import axios, { AxiosError, AxiosResponse } from 'axios';
import { getLogger } from '../diagnostics/logger';
import { getSimManagementErrorFromAxiosError } from '.';
import { TariffDropdownItem } from '../components/ui/input/DropdownInput';
import { Tariff, TariffConfigurationAttributes } from '../models/transfer/input/Tariff';

import config from '../config';
const log = getLogger('simManagement.api.simProvisionApi');

export function getTariffName(tariffNumber: number): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    axios
      .get(`${config.API_BASE_URL}api/tariff/${tariffNumber}/name`)
      .then((response: AxiosResponse<{ name: string }>) => {
        const tariffName = response.data.name;
        resolve(tariffName);
      })
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to load tariffs.', simManagementError);
        reject(simManagementError);
      });
  });
}

export interface TariffFilter {
  accountId: number;
  networkId: number;
}

export function getTariffs(filter: TariffFilter): Promise<TariffDropdownItem[]> {
  const { accountId, networkId } = filter;
  const select = 'name,number,requiresDataBoltOn,isLegacy,supportsFullPooling,configurationAttributes';
  const url = `${config.API_BASE_URL}api/account/${accountId}/network/${networkId}/tariff/?select=${select}`;
  return new Promise<TariffDropdownItem[]>((resolve, reject) => {
    axios
      .get(url)
      .then(
        (
          response: AxiosResponse<{
            count: number;
            totalCount?: number;
            result: Tariff[];
          }>,
        ) => {
          const dropDownItems: TariffDropdownItem[] = response.data.result.map((t: any) => {
            return {
              key: t.number,
              label: t.name,
              isLegacy: t.isLegacy,
              supportsFullPooling: t.supportsFullPooling,
              configurationAttributes: JSON.parse(t.configurationAttributes) as TariffConfigurationAttributes, 
            };
          });

          resolve(dropDownItems);
        },
      )
      .catch((error: any) => {
        const simManagementError = getSimManagementErrorFromAxiosError(error as AxiosError);
        log.error('Failed to load tariffs.', simManagementError);
        reject(simManagementError);
      });
  });
}
